import { render, staticRenderFns } from "./BeneficiaryDied.vue?vue&type=template&id=4ee12734"
import script from "./BeneficiaryDied.vue?vue&type=script&lang=js"
export * from "./BeneficiaryDied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports